import {
  SET_CHAT_HEADER_TITLE,
  SET_CHAT_SUBTITLE,
  SET_CHAT_PARM_ENABLE_TEXT_AREA,
  SET_CHAT_PARM_LANGUAGE,
  RENDER_CHAT,
  SET_CHAT_WIDGET_OPENED,
  SET_UNREAD_MESSAGE_COUNT,
} from "./types";
import store from "../../redux";
import { setRetryAction } from "../../common/CustomError";

export const setChatHeaderTitle = (chatTitle) => (dispatch) => {
  try {
    if (store.getState().chatReducer.chatTitle !== chatTitle) {
      dispatch({ type: SET_CHAT_HEADER_TITLE, payload: chatTitle });
    }
  } catch (error) {
    console.error("setChatHeaderTitle Error", error);
  }
};

export const setChatSubtitle = (chatSubtitle) => (dispatch) => {
  try {
    if (store.getState().chatReducer.chatSubtitle !== chatSubtitle) {
      dispatch({ type: SET_CHAT_SUBTITLE, payload: chatSubtitle });
    }
  } catch (error) {
    console.error("setChatSubitle Error", error);
  }
};

export const setChatParmEnableTextArea = (enableTextArea) => (dispatch) => {
  try {
    if (
      store.getState().chatReducer.chatParmEnableTextArea !== enableTextArea
    ) {
      dispatch({
        type: SET_CHAT_PARM_ENABLE_TEXT_AREA,
        payload: enableTextArea,
      });
    }
  } catch (error) {
    console.error("setChatParmEnableTextArea Error", error);
  }
};

export const setChatParmLanguage =
  ({ language, changeLanguage }) =>
  (dispatch) => {
    try {
      if (store.getState().chatReducer.chatParmLanguage !== language) {
        changeLanguage(language);
        dispatch({
          type: SET_CHAT_PARM_LANGUAGE,
          payload: language,
        });
      }
    } catch (error) {
      console.error("setChatParmLanguage Error", error);
    }
  };

export const setChatWidgetOpened = (chatWidgetOpened) => (dispatch) => {
  try {
    if (store.getState().chatReducer.chatWidgetOpened !== chatWidgetOpened) {
      dispatch({
        type: SET_CHAT_WIDGET_OPENED,
        payload: chatWidgetOpened,
      });
    }
  } catch (error) {
    console.error("setChatWidgetOpened Error", error);
  }
};

export const setUnreadMessageCount = (unreadMessageCount) => (dispatch) => {
  try {
    if (
      store.getState().chatReducer.unreadMessageCount !== unreadMessageCount
    ) {
      dispatch({
        type: SET_UNREAD_MESSAGE_COUNT,
        payload: unreadMessageCount,
      });
    }
  } catch (error) {
    console.error("setUnreadMessageCount Error", error);
  }
};

export const renderChat = (pane) => (dispatch) => {
  try {
    setRetryAction(pane?.errorPane?.retryAction);
    if (store.getState().chatReducer.render !== pane) {
      dispatch({ type: RENDER_CHAT, payload: pane });
    }
  } catch (error) {
    console.error("renderChat Error", error);
  }
};
